module.exports = __webpack_public_path__ + "static/img/12.e34fe05b.png";